import "./MicButton.css";

const MicButton = ({ isCalling, onClick, label, isLoading, isExhausted }) => {
  return (
    <button
      className={`mic-button ${isCalling ? "listening" : ""} ${isExhausted ? "exhausted" : ""}`}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-audio-lines-icon lucide-audio-lines"
      >
        <path d="M2 10v3" />
        <path d="M6 6v11" />
        <path d="M10 3v18" />
        <path d="M14 8v7" />
        <path d="M18 5v13" />
        <path d="M22 10v3" />
      </svg>
      {isLoading ? (
        <div className="lottie-wrapper">Loading...</div>
      ) : (
        <>
          {isCalling ? (
            <span className="text">End Conversation</span>
          ) : (
            <span className="text">{label}</span>
          )}
        </>
      )}
    </button>
  );
};

export default MicButton;
